// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.toolbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #0669B3;
  padding: 0 30px;
}
.toolbar-container .title-container {
  display: flex;
  align-items: center;
}
.toolbar-container .title-container .logo-text1 {
  font-size: 1.3rem;
  font-weight: 550;
  color: #577d00;
}
.toolbar-container .title-container .logo-text2 {
  font-size: 1.3rem;
  font-weight: 550;
  margin-top: -8px;
  color: #0669B3;
}

@media only screen and (max-width: 1182px) {
  .logo-container {
    margin-right: 20px;
  }
  .text-container {
    margin-top: 3px;
    margin-left: -18px !important;
  }
  .logo-text {
    font-size: 1.7rem !important;
  }
}
@media only screen and (max-width: 893px) {
  .logo-container {
    transform: scale(0.6);
  }
  .text-container {
    margin-top: 5px;
    margin-left: -18px !important;
  }
  .logo-text {
    font-size: 1.3rem !important;
  }
}
@media only screen and (max-width: 810px) {
  .icon {
    margin-top: 5px;
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Toolbar.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AASJ;AAPI;EACI,aAAA;EACA,mBAAA;AASR;AAPQ;EACI,iBAAA;EACA,gBAAA;EACA,cDNM;ACelB;AAPQ;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDOC;ACEb;;AAFA;EACI;IACI,kBAAA;EAKN;EAFE;IACI,eAAA;IACA,6BAAA;EAIN;EADE;IACI,4BAAA;EAGN;AACF;AAAA;EACI;IACI,qBAAA;EAEN;EACE;IACI,eAAA;IACA,6BAAA;EACN;EAEE;IACI,4BAAA;EAAN;AACF;AAGA;EACI;IAEI,eAAA;IACA,mBAAA;EAFN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n$dashboard-blue: #0d6efd;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n// $DCSD-logo-green: #84ae30; // old - does not pass\n// $DCSD-logo-green: #94B741; // this is the color from district site (see kellys screen shot)\n$DCSD-logo-green: #577d00; // darker green but does pass in FF\n$text: #414042;\n$white: #EDEDED;\n$shadow: #818181;\n$shadow2: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey0b: #e8e8e8; // new grey color\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$accessibility-red: rgb(218, 18, 18);\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n\n.toolbar-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-top: 1px solid $pearl-blue;\n    padding: 0 30px;\n\n    .title-container {\n        display: flex;\n        align-items: center;\n\n        .logo-text1 {\n            font-size: 1.3rem;\n            font-weight: 550;\n            color: $DCSD-logo-green;\n        }\n        .logo-text2 {\n            font-size: 1.3rem;\n            font-weight: 550;\n            margin-top: -8px;\n            color: $pearl-blue;\n        }\n    }\n}\n\n// ----------------------------------------------------\n// Media queries\n@media only screen and (max-width: 1182px) {\n    .logo-container {\n        margin-right: 20px;\n    }\n\n    .text-container {\n        margin-top: 3px;\n        margin-left: -18px !important;\n    }\n\n    .logo-text {\n        font-size: 1.7rem !important;\n    }\n}\n\n@media only screen and (max-width: 893px) {\n    .logo-container {\n        transform: scale(.6);\n    }\n\n    .text-container {\n        margin-top: 5px;\n        margin-left: -18px !important;\n    }\n\n    .logo-text {\n        font-size: 1.3rem !important;\n    }\n}\n\n@media only screen and (max-width: 810px) {\n    .icon {\n        // border: 3px solid red;\n        margin-top: 5px;\n        transform: scale(1);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
